import React, { useState } from 'react';
import { api_with_method } from '../../../../redux/api_funcs';
import { get_api_url } from '../../../../utils/urls';
// import Toast from '../../../util_components/success_toast';

function RenewMembershipButton({ onClose }) {
  const params = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
  const initialUUID = params?.get('id') || '';

  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reason, setReason] = useState('');
  //   const [toast, setToast] = useState<{ type: 'success' | 'error'; message: string } | null>(null);

  const handleRenewClick = () => {
    setShowPopup(true);
  };

  const handleConfirm = async () => {
    setLoading(true);
    try {
      const apiUrl = await get_api_url('renew_recurring_subscription_v1');
      const payload = {
        student_uuid: initialUUID,
        reason: reason
      };

      const response = await api_with_method('post', apiUrl, payload, true);
      console.log('Membership renewal response:', response.data);
      alert('Membership Renewal Successful');
      onClose();

      //   setToast({ type: 'success', message: 'Membership Renewed' });
    } catch (error) {
      console.error('Error in renewing membership:', error);
      alert('Renewal Failed');

      //   setToast({ type: 'error', message: 'Error in renewing membership' });
    } finally {
      setLoading(false);
      setShowPopup(false);
    }
  };

  return (
    <div>
      {/* {toast && <Toast type={toast.type} message={toast.message} />} */}
      {!showPopup && (
        <>
          <div>
            <p className="font-bold">Are you sure you want to renew user membership?</p>
          </div>

          <div className="flex justify-center gap-4 py-6">
            <button
              onClick={handleRenewClick}
              className="bg-blue-600' text-white px-6 py-2 w-full rounded"
            >
              Confirm
            </button>
            <button
              onClick={onClose}
              className="bg-gray-200 text-black px-6 py-2 w-full rounded  border-borderColor"
            >
              Cancel
            </button>
          </div>
        </>
      )}

      {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
          <div className="bg-white p-6 rounded-lg shadow-lg min-w-[300px] text-center">
            <h3 className="text-lg font-semibold mb-2">Confirm Membership Renewal</h3>

            <div>
              <div className="mb-3">
                <label
                  className="block text-sm text-gray-700 mb-1 mt-6 font-semibold text-left"
                  style={{ textTransform: 'unset' }}
                >
                  Reason For Membership renewal <span className="text-[red]">*</span>
                </label>
                <textarea
                  className="h-[80px] border border-gray-300 rounded-md w-full p-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  placeholder="Enter the reason for the Renewal..."
                />
              </div>
              <p>Are you sure you want to renew the membership?</p>
              <div className="mt-4 flex justify-center gap-3">
                <button
                  onClick={handleConfirm}
                  disabled={!reason}
                  className={`px-4 py-2 rounded text-white w-full ${
                    !reason
                      ? 'bg-green-600  border-borderColor opacity-60 cursor-not-allowed'
                      : 'bg-green-600  border-borderColor hover:bg-green-700 cursor-pointer'
                  }`}
                >
                  {loading ? 'Processing...' : 'Confirm'}
                </button>
                <button
                  onClick={() => setShowPopup(false)}
                  className="w-full bg-gray-300 text-black  border-borderColor px-4 py-2 rounded hover:bg-gray-400"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default RenewMembershipButton;
